const home = r => require.ensure([], () => r(require('@/views/index')), 'home')
const resolve = r => require.ensure([], () => r(require('@/views/resolve')), 'resolve')
const about = r => require.ensure([], () => r(require('@/views/about')), 'about')

export default [{
  path: '/',
  name: 'home',
  meta: {
    title: '首页'
  },
  component: home
}, {
  path: '/resolve',
  name: 'resolve',
  meta: {
    title: '解决方案'
  },
  component: resolve
}, {
  path: '/about_us',
  name: 'about',
  meta: {
    title: '关于我们'
  },
  component: about
}]



// WEBPACK FOOTER //
// ./src/router/routes.js